import { useSyncExternalStore } from "react"

/** La soglia oltre la quale la regia smette di essere un telefono e si
 *  dispone a colonne. Deve restare uguale a quella di regia.css. */
const LARGO = "(min-width: 900px)"

function iscrivi(avvisa: () => void) {
  const mq = matchMedia(LARGO)
  mq.addEventListener("change", avvisa)
  return () => mq.removeEventListener("change", avvisa)
}

/** Vero sullo schermo di un portatile. Serve solo per ciò che il CSS non può
 *  decidere da solo: un riquadro aperto per default, un elenco in più. */
export function useLargo(): boolean {
  return useSyncExternalStore(iscrivi, () => matchMedia(LARGO).matches)
}
